import { DialogContentText, DialogTitle, styled } from "@mui/material";

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
`;

export const StyledDialogContentText = styled(DialogContentText)`
  padding-inline: 12px;
`;
